import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Input, Button } from "@fragments";
import { LinkRounded, EditRounded, DeleteRounded, CheckRounded } from "@mui/icons-material";

export default function LinkInfo({ data, onUpdate, onDelete }) {
    const { t } = useTranslation("contentModals");
    const [open, setOpen] = useState(false);
    const [text, setText] = useState(data.text);
    const [url, setUrl] = useState(data.url);

    useEffect(() => {
        setText(data.text);
        setUrl(data.url);
    }, [data]);

    function handleDelete() {
        window.openConfirm({
            title: t("manageContent.attachments.deleteTitle"),
            headline: t("manageContent.attachments.deleteHeadline"),
            buttons: [
                {
                    text: t("common:actions.delete"),
                    onClick: onDelete,
                    color: "error",
                    variant: "contained"
                },
                {
                    text: t("common:actions.cancel"),
                    variant: "text"
                }
            ]
        });
    }

    if (!open) {
        return (
            <div className="description-link-row">
                <div className="description-link bsf-9">
                    <LinkRounded className="url-icon" />
                    <span className="title">{text || <i>{t("manageContent.attachments.notConfigured")}</i>}</span>
                    <span className="url">{url}</span>
                    <Button
                        color="overlay"
                        onClick={() => setOpen(true)}
                        size="small"
                        icon={<EditRounded />}
                    />
                    <Button
                        color="overlay"
                        onClick={handleDelete}
                        size="small"
                        icon={<DeleteRounded />}
                    />
                </div>
            </div>
        );
    }

    return (
        <div className="link-info-block mt-2 mb-3 px-2 py-2">
            <Input.Text
                autoFocus
                emoji
                variant="dark"
                size={25}
                value={text}
                onInput={(val) => {
                    setText(val);
                    onUpdate({ ...data, text: val });
                }}
                label={t("manageContent.attachments.linkTitleLabel")}
                placeholder={t("manageContent.attachments.linkTitlePlaceholder")}
            />
            <Input.Text
                start="https://"
                variant="dark"
                size={180}
                value={url}
                onInput={(val) => {
                    setUrl(val);
                    onUpdate({ ...data, url: val });
                }}
                label={t("common:fields.link")}
                placeholder={t("manageContent.attachments.urlPlaceholder")}
            />
            <div className="mt-1 link-buttons-footer">
                <Button
                    color="error"
                    onClick={handleDelete}
                    endIcon={<DeleteRounded />}
                    text={t("common:actions.delete")}
                />
                <Button
                    color="overlay"
                    onClick={() => {
                        if (!text || text.trim().length === 0) {
                            window.setSnackbar(t('manageContent.attachments.errors.missingTitle'), 'error');
                            return;
                        }
                        if (!url || url.trim().length === 0) {
                            window.setSnackbar(t('manageContent.attachments.errors.missingUrl'), 'error');
                            return;
                        }
                        const urlPattern = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;
                        if (!urlPattern.test(url)) {
                            window.setSnackbar(t('manageContent.attachments.errors.invalidUrl'), 'error');
                            return;
                        }

                        setOpen(false);
                    }}
                    endIcon={<CheckRounded />}
                    text={t("manageContent.attachments.doneButton")}
                />
            </div>
        </div>
    );
}
